import React from 'react';
import { Power } from 'lucide-react';

export interface OnOffStyle03Props {
  isOn: boolean;
  disabled?: boolean;
  loading?: boolean;
  onToggle: () => void;
  size?: 'small' | 'medium' | 'large';
  label?: string;
}

/**
 * OnOff Style 03 - Card Style
 * Full-width card with large toggle area
 */
export const Style03_Card: React.FC<OnOffStyle03Props> = ({
  isOn,
  disabled = false,
  loading = false,
  onToggle,
  size = 'medium',
  label = '電源開關'
}) => {
  const sizeConfig = {
    small: { padding: 'p-3', icon: 'w-6 h-6', text: 'text-sm' },
    medium: { padding: 'p-4', icon: 'w-8 h-8', text: 'text-base' },
    large: { padding: 'p-6', icon: 'w-10 h-10', text: 'text-lg' }
  };

  const config = sizeConfig[size];

  return (
    <button
      onClick={onToggle}
      disabled={disabled || loading}
      className={`group ${config.padding} w-full rounded-2xl transition-all duration-300 ${
        isOn 
          ? 'bg-gradient-to-r from-green-500/20 to-emerald-500/20 border border-green-500/50 hover:from-red-500/20 hover:to-orange-500/20 hover:border-red-500/50' 
          : 'bg-slate-800/50 border border-slate-700/50 hover:bg-green-500/20 hover:border-green-500/50'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className={`${config.icon} rounded-full flex items-center justify-center transition-colors ${
            isOn ? 'bg-green-500 text-white group-hover:bg-red-500' : 'bg-slate-700 text-slate-400 group-hover:bg-green-500 group-hover:text-white'
          }`}>
            {loading ? (
              <span className="animate-spin w-4 h-4 border-2 border-current border-t-transparent rounded-full" />
            ) : (
              <Power className="w-1/2 h-1/2" />
            )}
          </div>
          <span className={`${config.text} font-medium ${isOn ? 'text-green-400' : 'text-slate-300'}`}>
            {label}
          </span>
        </div>
        <span className={`${config.text} font-bold ${isOn ? 'text-green-400' : 'text-slate-500'}`}>
          <span className="group-hover:hidden">{isOn ? 'ON' : 'OFF'}</span>
          <span className="hidden group-hover:inline">{isOn ? 'OFF' : 'ON'}</span>
        </span>
      </div>
    </button>
  );
};

export default Style03_Card;
